import React, { useEffect, useState, useContext, useRef } from "react";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import Select from "react-select";
import "antd/dist/antd.min.css";
import { Modal } from "react-bootstrap";
import { DataGrid } from "@material-ui/data-grid";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@mui/material/Tooltip";
import Badge from "react-bootstrap/Badge";
import { Row, Col } from "react-bootstrap";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { confirmAlert } from "react-confirm-alert";

//Global State import
import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";

import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import toast from "react-hot-toast";
//Context import
import AuthContext from "../../../components/shared/Context";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const TCWiseInventoryStatusChild = () => {
  let navigate = useNavigate();
  const { loggedInUserDetails } = useContext(AuthContext);
  const [tcenters, setTcenters] = useState();
  const [selectedTC, setSelectedTC] = useState();
  const [data, setData] = useState([]);
  const [unfilteredData, setUnfilteredData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState({});
  const searchRef = useRef();
  const [editingEnabled, setEditingEnabled] = useState(false);
  const [expiredProducts, setExpiredProducts] = useState();
  const [itemwiseExpiredQty, setItemwiseExpiredQty] = useState([]);
  //Error Logging Service
  const { dateFormatter, errorLogApi } = useAtom(gbState);

  const calculateDaysLeft = (date) => {
    // Convert the given date string to a Date object
    const givenDate = new Date(date);

    // Calculate the difference between the current date and the given date in milliseconds
    const timeDiff = givenDate.getTime() - new Date().getTime();

    // Convert milliseconds to days and round down to the nearest integer
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

    // Update the state with the number of days left
    //setDaysLeft(days);
    return days;
  };

  //Get Expired Product Data
  const getExpiredProductsData = () => {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    let urlLink = `${process.env.REACT_APP_API_URL}/tcpwstock/${selectedTC?.id}`;

    axios
      .get(urlLink, config)
      .then((res) => {
        const oldData = res.data.product_stock;
        const ExpiredProduct = oldData.filter((product) => {
          return calculateDaysLeft(product?.product_stock?.expiry_date) <= 0;
        });
        const updatedData = ExpiredProduct.map((data) => {
          return {
            ...data,
            id: data?._id,
            stock_type: data?.product_stock?.stock_type,
            product_name:
              data?.product_stock?.product_id?.products?.product_name,
            category:
              data?.product_stock?.product_id?.products?.category_id?.category,
            item_code: data?.product_stock?.item_code,
            measuring_unit:
              data?.product_stock?.product_id?.products?.measuring_unit,
            company_name:
              data?.product_stock?.product_id?.products?.company_name,
            product_expiry: data?.product_stock?.expiry_date,
            tc_name: data?.product_stock?.tc_id?.tcenters?.name_tc,
            state: data?.product_stock?.tc_id?.tcenters?.state,
            quantity:
              data?.product_stock?.quantity +
              " " +
              data?.product_stock?.product_id?.products?.storage_unit,
            updatedAt: data?.updatedAt,
          };
        });
        setExpiredProducts(updatedData);
      })
      .catch((err) => console.log("error", err));
  };

  //Modify the useEffect to use the new function
  useEffect(() => {
    if (selectedTC?.id) {
      getExpiredProductsData();
      // console.log(selectedTC);
    }
  }, [selectedTC]);

  //Get All TCs
  useEffect(() => {
    const getTCDataFromServer = () => {
      let userToken = localStorage.getItem("token");

      let urlLink = `${process.env.REACT_APP_API_URL}/tc/`;

      if (loggedInUserDetails.role === "ST_ADM_ACCESS") {
        urlLink = `${process.env.REACT_APP_API_URL}/tc/state/${loggedInUserDetails.state}`;
      }

      const config = {
        method: "GET",
        url: urlLink,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };

      axios(config)
        .then(function (response) {
          //console.log(JSON.stringify(response.data.treatment_center));
          const oldData = response.data.treatment_center;
          const filteredTC = oldData?.filter(
            (tc) => tc?.tcenters?.tc_type === "government"
          );
          const updatedData = filteredTC.map((data) => {
            return {
              ...data,
              id: data?._id,
              value: data?._id,
              name_tc: data?.tcenters?.name_tc,
              hdcc_no: data?.tcenters?.hdcc_no,
              state: data?.tcenters?.state,
              district: data?.tcenters?.district,
              tcid: data?.tcenters?.treatment_center_id,
              label: (
                <TCDetails
                  tc_id={data?.tcenters?.treatment_center_id}
                  tc_name={data.tcenters.name_tc}
                />
              ),
              dataLabel: data?.tcenters?.name_tc,
            };
          });
          // console.log(updatedData);
          setTcenters(updatedData);
        })
        .catch(function (error) {
          //console.log(error.message);
        });
    };

    getTCDataFromServer();
  }, []);

  //Get Current status of inventory
  const getTCInventoryDataFromServer = () => {
    // console.log(selectedTC);
    // return;
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };
    const bodyParameters = {
      key: "value",
    };
    let urlLink = `${process.env.REACT_APP_API_URL}/tcstock/${selectedTC?.id}`;
    axios
      .get(urlLink, config)
      .then((res) => {
        const oldData = res.data.current_stock;
        //console.log(oldData);
        const updatedData = oldData.map((data) => {
          //   console.log(data.purchase_inventory.product_id.products);
          return {
            ...data,
            id: data?._id,
            product_name:
              data?.current_stock?.product_id?.products?.product_name,
            category:
              data?.current_stock?.product_id?.products?.category_id?.category,
            item_code: data?.current_stock?.item_code,
            opening_stock:
              data?.current_stock?.opening_stock +
              " " +
              data?.current_stock?.product_id?.products?.storage_unit,
            purchase_qty:
              data?.current_stock?.purchase_qty +
              " " +
              data?.current_stock?.product_id?.products?.storage_unit,
            sale_qty:
              data?.current_stock?.sale_qty +
              " " +
              data?.current_stock?.product_id?.products?.storage_unit,
            expired_qty:
              "0 " + data?.current_stock?.product_id?.products?.storage_unit,
            closing_stock:
              data?.current_stock?.closing_stock +
              " " +
              data?.current_stock?.product_id?.products?.storage_unit,
            state: data?.current_stock?.tc_id?.tcenters?.state,
            tc_name: data?.current_stock?.tc_id?.tcenters?.name_tc,
            updatedAt: data?.updatedAt,
          };
        });
        //console.log(updatedData);
        setData(updatedData);
        setUnfilteredData(updatedData);
      })
      .catch((err) => console.log("error", err));
  };

  useEffect(() => {
    if (selectedTC?.id) {
      getTCInventoryDataFromServer();
    }
  }, [selectedTC]);

  //Once the Expierd product is loaded
  useEffect(() => {
    if (expiredProducts?.length > 0) {
      // Group expired products by item_code and sum quantities
      const itemwiseQty = expiredProducts.reduce((acc, product) => {
        const itemCode = product.item_code;
        const quantity = parseInt(product.quantity?.split(" ")[0]) || 0;

        if (!acc[itemCode]) {
          acc[itemCode] = {
            item_code: itemCode,
            quantity: 0,
          };
        }
        acc[itemCode].quantity += quantity;
        return acc;
      }, {});

      // Convert to array format
      const itemwiseQtyArray = Object.values(itemwiseQty);
      setItemwiseExpiredQty(itemwiseQtyArray);
    }
  }, [expiredProducts]);

  //When itemwiseexpired is set then again refill the data
  useEffect(() => {
    if (itemwiseExpiredQty?.length > 0) {
      // Create a map of expired quantities by item code
      const expiredQtyMap = itemwiseExpiredQty.reduce((acc, item) => {
        acc[item.item_code] = item.quantity;
        return acc;
      }, {});

      // Add expired_qty field and update closing_stock for each row in data
      const updatedData = data.map((row) => {
        const expiredQty = expiredQtyMap[row.item_code] || 0;
        const currentClosingStock =
          parseInt(row.closing_stock?.split(" ")[0]) || 0;
        const storageUnit =
          row.current_stock?.product_id?.products?.storage_unit;

        // Calculate new closing stock (ensure it doesn't go below 0)
        const newClosingStock = Math.max(0, currentClosingStock - expiredQty);

        return {
          ...row,
          expired_qty: expiredQty + " " + storageUnit,
          closing_stock: newClosingStock + " " + storageUnit,
        };
      });

      setData(updatedData);
    }
  }, [itemwiseExpiredQty]);

  const useStyles = makeStyles(() => ({
    multiLineCell: {
      display: "flex",
      wordBreak: "keep-all",
      wordWrap: "break-word",
      overflowWrap: "break-word",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      lineHeight: "1.2rem",
      height: "auto",
    },
  }));

  const MultiLineCellRendererv1 = (params) => {
    const classes = useStyles();
    return (
      <div className={classes.multiLineCell}>
        <span id="content1">{params.row.product_name}</span>
        <span id="content2">
          <small className="small-font-size">{params.row.item_code}</small>
        </span>
      </div>
    );
  };

  const MultiLineCellRenderer = (params) => {
    const classes = useStyles();
    return (
      <div className={classes.multiLineCell}>
        <span id="content1" className="text-bold">
          {editingEnabled && (
            <i
              className="mdi mdi-square-edit-outline"
              style={{ fontSize: "15px", color: "red", cursor: "pointer" }}
              onClick={() => {
                setCurrentRecord(params.row);
                setOpenModal(true);
              }}
            ></i>
          )}
          {params.row.product_name}
        </span>
        <span id="content2">
          <small className={`${editingEnabled && "ms-3"} small-font-size`}>
            {params.row.item_code}
          </small>
        </span>
      </div>
    );
  };

  const columns = [
    {
      field: "product_name",
      headerName: "Product",
      width: 240,
      renderCell: (params) => (
        <MultiLineCellRenderer
          {...params}
          editingEnabled={editingEnabled}
          setCurrentRecord={setCurrentRecord}
          setOpenModal={setOpenModal}
        />
      ),
    },
    {
      field: "category",
      headerName: "Category",
      width: 150,
    },
    {
      field: "opening_stock",
      headerName: "Opening Stock",
      width: 160,
      filterable: false,
      disableColumnMenu: true,
      align: "center",
    },
    {
      field: "purchase_qty",
      headerName: "Alloted",
      width: 110,
      filterable: false,
      sortable: true,
      disableColumnMenu: true,
      align: "center",
    },
    {
      field: "sale_qty",
      headerName: "Consumed",
      width: 130,
      filterable: false,
      sortable: true,
      disableColumnMenu: true,
      align: "center",
    },
    {
      field: "expired_qty",
      headerName: "Expired",
      width: 130,
      filterable: false,
      sortable: true,
      disableColumnMenu: true,
      align: "center",
      renderCell: (params) => {
        // Extract numeric value from string like "120 vial(s)"
        const numericValue = parseInt(params?.row?.expired_qty?.split(" ")[0]);
        return (
          <Badge
            bg={numericValue > 0 ? "danger" : "success"}
            style={{ width: "100%", display: "block", fontSize: "0.8rem" }}
          >
            {params?.row?.expired_qty}
          </Badge>
        );
      },
    },
    {
      field: "closing_stock",
      headerName: "Closing Stock",
      width: 160,
      filterable: false,
      disableColumnMenu: true,
      align: "center",
    },

    {
      field: "tc_name",
      headerName: "TC Name",
      width: 150,
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "state",
      headerName: "State",
      width: 110,
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
    },
  ];

  const viewRecord = (rec) => {
    setCurrentRecord(rec);
    setOpenModal(true);
  };

  const handleSearch = (e) => {
    console.log("Search Value...", e);

    if (e) {
      setData(
        unfilteredData.filter((item) => {
          return (
            item?.item_code?.toLowerCase().includes(e?.toLowerCase()) ||
            item?.product_name?.toLowerCase().includes(e?.toLowerCase()) ||
            item?.purchase_qty?.toLowerCase().includes(e?.toLowerCase()) ||
            item?.sale_qty?.toLowerCase().includes(e?.toLowerCase()) ||
            item?.category?.toLowerCase().includes(e?.toLowerCase()) ||
            item?.closing_stock?.toLowerCase().includes(e?.toLowerCase())
          );
        })
      );
    } else {
      getTCInventoryDataFromServer();
      setData(unfilteredData);
    }
  };

  const clearSearch = () => {
    searchRef.current.value = null;
    getTCInventoryDataFromServer();
  };

  const generatePdfContent = (data) => {
    // Make sure data is passed as an argument
    const currentDate = new Date().toLocaleDateString();

    const tableBody = [
      [
        "Product",
        "Category",
        "Opening Stock",
        "Allotted",
        "Consumed",
        "Closing Stock",
      ],
      ...data.map((d) => [
        // Assuming 'data' is an array of objects
        `${d.product_name} (${d.item_code})`,
        d.category,
        d.opening_stock,
        d.purchase_qty,
        d.sale_qty,
        d.closing_stock,
      ]),
    ];

    const content = [
      {
        text: `${selectedTC?.name} - ${currentDate}`, // Included currentDate
        style: "title",
      },
      {
        table: {
          headerRows: 1,
          //    widths: ["auto", "auto", "auto", "auto", "auto", "auto"], // 6 widths for 6 columns
          widths: ["*", "*", "*", "*", "*", "*"], // Distribute available width evenly across columns
          body: tableBody,
        },
        style: "table",
      },
    ];

    const docDefinition = {
      content,
      styles: {
        title: {
          fontSize: 16,
          bold: true,
          marginBottom: 10,
        },
        table: {
          margin: [0, 10, 0, 10],
        },
      },
      pageOrientation: "landscape", // Set the page orientation to landscape
    };

    return docDefinition;
  };

  const downloadPdfDocument = () => {
    if (!data?.length) return toast.error("Nothing to download");
    const docDefinition = generatePdfContent(data);
    const pdfDoc = pdfMake.createPdf(docDefinition);
    const timestamp = new Date().toISOString().replace(/[\-\:\.]/g, "_");
    const filename = `patient_data_${timestamp}.pdf`;
    pdfDoc.download(filename);
  };

  return (
    <div>
      <span className="card-title">
        <h3>Total TC Stocks (Current Status) </h3>
      </span>
      <Row className="align-items-center mb-3">
        <Col md={4}>
          <Select
            name="tc-select"
            onChange={(selected, dropdown) => {
              setSelectedTC({ id: selected?._id, name: selected?.name_tc });
            }}
            placeholder="Select TC..."
            options={tcenters}
            filterOption={(option, input) => {
              return option.data.dataLabel
                .toLowerCase()
                .includes(input.toLowerCase());
            }}
            menuPortalTarget={document.body}
            menuPosition={"fixed"}
          />
        </Col>
        <Col md={4} className="d-flex gap-2 justify-content-end ms-auto">
          <button className="btn btn-primary" onClick={downloadPdfDocument}>
            Download PDF
          </button>
          <button
            className={`btn ${editingEnabled ? "btn-danger" : "btn-info"}`}
            onClick={() => {
              if (!editingEnabled) {
                confirmAlert({
                  title: "",
                  message:
                    "I understand that changing values can adversly affect the inventory.",
                  buttons: [
                    {
                      label: "Yes",
                      onClick: () => setEditingEnabled(true),
                    },
                    {
                      label: "No",
                    },
                  ],
                });
              } else {
                setEditingEnabled(false);
              }
            }}
          >
            <i
              className={`mdi ${
                editingEnabled ? "mdi-pencil-off" : "mdi-pencil"
              }`}
            />
          </button>
        </Col>
      </Row>
      <div className="patientListSearch">
        <InputGroup className="mb-3">
          <InputGroup.Text id="basic-addon1">Filter</InputGroup.Text>
          <Form.Control
            placeholder="Product / State / Code / Company ..."
            aria-label="Search"
            aria-describedby="basic-addon1"
            name="searchPatients"
            ref={searchRef}
            onChange={(e) => handleSearch(e.target.value)}
          />
          <InputGroup.Text>
            <i
              className="mdi mdi-delete-outline"
              onClick={clearSearch}
              style={{ cursor: "pointer" }}
            ></i>
          </InputGroup.Text>
        </InputGroup>
      </div>
      <DataGrid
        rows={data}
        disableSelectionOnClick
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[10]}
        displayTitle="Current Stocks"
        checkboxSelection
        style={{ height: "60vh" }}
      />
      {/* {JSON.stringify(expiredProducts)} */}
      {/* {JSON.stringify(data)} */}
      {/* Modal Popup */}
      <Modal show={openModal} centered>
        <Modal.Header closeButton onClick={() => setOpenModal(false)}>
          <Modal.Title>Update Current Inventory</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalContent
            currentRecord={currentRecord}
            setOpenModal={setOpenModal}
            getTCInventoryDataFromServer={getTCInventoryDataFromServer}
          />
        </Modal.Body>
      </Modal>

      {/* {JSON.stringify(currentRecord)} */}
    </div>
  );
};

const ModalContent = ({
  currentRecord,
  setOpenModal,
  getTCInventoryDataFromServer,
}) => {
  const [formData, setFormData] = useState({
    ...currentRecord,
    opening_stock: currentRecord?.current_stock?.opening_stock,
    purchase_qty: currentRecord?.current_stock?.purchase_qty,
    sale_qty: currentRecord?.current_stock?.sale_qty,
    closing_stock: currentRecord?.current_stock?.closing_stock,
  });
  const [currentStock, setCurrentStock] = useState();
  const [confirmUpdate, setConfirmUpdate] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 3;

  // Calculate pagination values
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = currentStock?.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil((currentStock?.length || 0) / rowsPerPage);

  // Handle page changes
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  //Load product using useEffect
  const badgeStatus = {
    0: { badge: "warning", label: "PENDING" },
    1: { badge: "primary", label: "PROCESSING" },
    2: { badge: "danger", label: "REJECTED" },
    3: { badge: "success", label: "COMPLETED" },
  };

  useEffect(() => {
    const getDataFromServer = () => {
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };

      const bodyParameters = {
        key: "value",
      };

      let urlLink = `${process.env.REACT_APP_API_URL}/tcpwstock/single/${formData?.item_code}/${formData?.current_stock?.tc_id?._id}`;

      axios
        .get(urlLink, config)
        .then((res) => {
          const oldData = res.data.product_stock;
          // console.log(oldData);
          const updatedData = oldData.map((data) => {
            //   console.log(data.purchase_inventory.product_id.products);
            return {
              ...data,
              id: data?._id,
              stock_type: data?.product_stock?.stock_type, //newly added
              product_name:
                data?.product_stock?.product_id?.products?.product_name,
              category:
                data?.product_stock?.product_id?.products?.category_id
                  ?.category,
              item_code: data?.product_stock?.item_code,
              measuring_unit:
                data?.product_stock?.product_id?.products?.measuring_unit,
              company_name:
                data?.product_stock?.product_id?.products?.company_name,
              product_expiry: data?.product_stock?.expiry_date,
              tc_name: data?.product_stock?.tc_id?.tcenters?.name_tc,
              state: data?.product_stock?.tc_id?.tcenters?.state,
              quantity:
                data?.product_stock?.quantity +
                " " +
                data?.product_stock?.product_id?.products?.storage_unit,
              updatedAt: data?.updatedAt,
            };
          });
          // console.log(updatedData);
          setCurrentStock(updatedData);
        })
        .catch((err) => console.log("error", err));
    };

    getDataFromServer();
  }, []);

  const handleChangeValue = ({ currentTarget: input }) => {
    setFormData({
      ...formData,
      [input.name]: input.value,
    });
  };

  const handleSubmit = () => {
    // Validate closing stock calculation
    const calculatedClosingStock =
      parseInt(formData?.opening_stock) +
      parseInt(formData?.purchase_qty) -
      parseInt(formData?.sale_qty);

    if (parseInt(formData?.closing_stock) !== calculatedClosingStock) {
      toast.error(
        "Closing stock must equal (Opening Stock + Purchase Qty) - Sale Qty"
      );
      return;
    }

    let userToken = localStorage.getItem("token");
    const config = {
      method: "POST",
      url: `${process.env.REACT_APP_API_URL}/tcstock/update/${formData?._id}`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: {
        _id: formData?.id,
        "current_stock.opening_stock": formData?.opening_stock,
        "current_stock.purchase_qty": formData?.purchase_qty,
        "current_stock.sale_qty": formData?.sale_qty,
        "current_stock.closing_stock": formData?.closing_stock,
      },
    };
    axios(config)
      .then(function (response) {
        toast.success("Record updated Successfully.");
        getTCInventoryDataFromServer();
        setOpenModal(false);
      })
      .catch(function (error) {
        toast.error(error?.response?.data?.message);
        console.log(error.message);
      });
  };

  return (
    <div className="container-fluid">
      <div className="card mb-1 p-3">
        <div className="d-flex flex-column">
          <h4 className="text-primary mb-2">{formData?.product_name}</h4>
          <div className="d-flex gap-3 mb-1">
            <span className="badge bg-info">Code: {formData?.item_code}</span>
            <span className="badge bg-secondary">{formData?.category}</span>
          </div>
        </div>
      </div>
      {/* Current Stock Status */}
      <table className="table table-bordered table-hover">
        <thead className="table-light">
          <tr>
            <td colSpan={3}>
              <h5 className="text-primary">Current Stock Status</h5>
            </td>
          </tr>
          <tr>
            <th>Expiry Date</th>
            <th>Type</th>
            <th>Quantity</th>
          </tr>
        </thead>
        <tbody>
          {currentRows?.map((stock) => (
            <tr key={stock.id}>
              <td>{new Date(stock?.product_expiry).toLocaleDateString()}</td>
              <td>
                {stock?.stock_type ? (
                  <Badge
                    bg={badgeStatus[1].badge}
                    style={{ width: "100%", display: "block" }}
                  >
                    LOCAL PURCHASE
                  </Badge>
                ) : (
                  <Badge
                    bg={badgeStatus[3].badge}
                    style={{ width: "100%", display: "block" }}
                  >
                    STATE ALLOCATION
                  </Badge>
                )}
              </td>
              <td>{stock?.product_stock?.quantity}</td>
            </tr>
          ))}
          <tr className="table-secondary">
            <td colSpan="2" className="text-end">
              <strong>Total</strong>
            </td>
            <td>
              {currentStock?.reduce(
                (total, stock) =>
                  total + Number(stock?.product_stock?.quantity),
                0
              )}
            </td>
          </tr>
        </tbody>
      </table>

      {/* Pagination Controls */}
      {currentStock && currentStock.length > rowsPerPage && (
        <div className="d-flex justify-content-center gap-2 mt-3">
          <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            &laquo; Previous
          </button>

          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index + 1}
              className={`btn btn-sm ${
                currentPage === index + 1
                  ? "btn-primary"
                  : "btn-outline-primary"
              }`}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </button>
          ))}

          <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next &raquo;
          </button>
        </div>
      )}

      <div className="table-responsive mt-3 bg-light border rounded p-4">
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">
              Opening Stock<span className="text-danger">*</span>
            </label>
            <div className="d-flex align-items-center">
              <input
                type="number"
                name="opening_stock"
                className="form-control me-2"
                placeholder="Opening Stock"
                onChange={handleChangeValue}
                value={formData?.opening_stock}
                min="0"
                required
              />
              <span className="text-muted">
                {formData?.current_stock?.product_id?.products?.storage_unit}
              </span>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">
              Issued<span className="text-danger">*</span>
            </label>
            <div className="d-flex align-items-center">
              <input
                type="number"
                name="purchase_qty"
                className="form-control me-2"
                placeholder="Consumed Stock"
                onChange={handleChangeValue}
                value={formData?.purchase_qty}
                min="0"
                required
              />
              <span className="text-muted">
                {formData?.current_stock?.product_id?.products?.storage_unit}
              </span>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">
              Consumed<span className="text-danger">*</span>
            </label>
            <div className="d-flex align-items-center">
              <input
                type="number"
                name="sale_qty"
                className="form-control me-2"
                placeholder="Consumed Stock"
                onChange={handleChangeValue}
                value={formData?.sale_qty}
                min="0"
                required
              />
              <span className="text-muted">
                {formData?.current_stock?.product_id?.products?.storage_unit}
              </span>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">
              Closing Stock<span className="text-danger">*</span>
            </label>
            <div className="d-flex align-items-center">
              <input
                type="number"
                name="closing_stock"
                className="form-control me-2"
                placeholder="Closing Stock"
                onChange={handleChangeValue}
                value={formData?.closing_stock}
                min="0"
                required
              />
              <span className="text-muted">
                {formData?.current_stock?.product_id?.products?.storage_unit}
              </span>
            </div>
          </div>
        </div>

        <div className="form-check mb-3">
          <input
            type="checkbox"
            className="form-check-input"
            id="confirmCheck"
            checked={confirmUpdate}
            onChange={(e) => setConfirmUpdate(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="confirmCheck">
            I understand that changing values can adversely affect the
            inventory.
          </label>
        </div>

        <div className="col-12 text-end">
          <button
            className="btn btn-secondary me-2"
            onClick={() => setOpenModal(false)}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={!confirmUpdate}
          >
            Update Stock
          </button>
        </div>
      </div>
    </div>
  );
};

const TCDetails = ({ tc_name, tc_id }) => {
  return (
    <div>
      <span className="text-bold">{tc_name}</span>
      <p className="text-black truncate text-light font-12" small>
        TC ID: {tc_id}
      </p>
    </div>
  );
};

export default TCWiseInventoryStatusChild;
